import classNames from 'classnames'

import { InputWrap } from '../../Input'
import {
  useTextareaClearHandler,
  useTextareaFocusHandler,
} from '../Textarea.hooks'
import { TextareaElement } from '../TextareaElement'
import { TextareaInlineActions } from '../TextareaInlineActions'

import * as styles from './TextareaOutlineField.module.css'

function TextareaOutlineField({
  autoFocus,
  className,
  clearable,
  disabled,
  error,
  errorText,
  helpText,
  info,
  label,
  maxLength,
  ref: forwardedRef,
  required,
  value,
  onChange,
  ...componentProps
}) {
  const { focused, handleBlur, handleFocus } =
    useTextareaFocusHandler(autoFocus)

  const { handleClear, textareaRef } = useTextareaClearHandler({
    forwardedRef,
    onBlur: handleBlur,
    onChange,
  })

  const showWrapCounter = !disabled && maxLength && focused
  const isClearable = clearable && value

  const textareaClassName = classNames(className, {
    [styles.clearable]: isClearable && !disabled,
  })

  return (
    <InputWrap
      disabled={disabled}
      error={error || errorText}
      helpText={helpText}
      info={info}
      label={label}
      maxLength={maxLength}
      required={required}
      value={value}
      withCounter={showWrapCounter}
    >
      <TextareaElement
        {...componentProps}
        className={textareaClassName}
        disabled={disabled}
        error={error || errorText}
        focused={focused}
        maxLength={maxLength}
        ref={textareaRef}
        value={value}
        onBlur={handleBlur}
        onChange={onChange}
        onFocus={handleFocus}
      >
        <TextareaInlineActions
          clearable={isClearable}
          disabled={disabled}
          onClear={handleClear}
        />
      </TextareaElement>
    </InputWrap>
  )
}

export default TextareaOutlineField
